// ==========================================================================
// Principles Grid (campaign-principles)
// ==========================================================================

(function () {
    'use strict';

    function init() {
        // Event delegation so it works no matter when the markup is added.
        document.addEventListener('click', function (e) {
            var toggle = e.target.closest('.js-toggle-principles-tile');
            if (!toggle) {
                return;
            }
            e.preventDefault();
            var tile = toggle.closest('.campaign-principles__tile-item');
            if (tile) {
                tile.classList.toggle('is-active');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
